import { fmtNum } from '../../utils/format';

export default function EodOCSubBar({
  exchanges,
  exch,
  tp,
  symbols,
  dates,
  expiries,
  symbol,
  date,
  expiry,
  loading,
  summary,
  onExchChange,
  onTpChange,
  onSymbolChange,
  onDateChange,
  onExpiryChange,
  onLoad,
}) {
  const S = summary || {};
  const ceOiClass = (S.totCEOI || 0) > (S.totPEOI || 0) ? 'sr' : 'sg';
  const peOiClass = (S.totPEOI || 0) > (S.totCEOI || 0) ? 'sg' : 'sr';
  const ceCoiClass = Math.abs(S.totCECOI || 0) > Math.abs(S.totPECOI || 0) ? 'sr' : 'sg';
  const peCoiClass = Math.abs(S.totPECOI || 0) > Math.abs(S.totCECOI || 0) ? 'sg' : 'sr';
  const canLoad = symbol && date && expiry;

  return (
    <div className="oc-sub">
      <label>
        EXCHANGE
        <select value={exch} onChange={e => onExchChange(e.target.value)}>
          {(exchanges.length ? exchanges : ['NSE']).map(e => (
            <option key={e} value={e}>{e}</option>
          ))}
        </select>
      </label>
      <label>
        TYPE
        <select value={tp} onChange={e => onTpChange(e.target.value)}>
          <option value="IDO">IDO · Index</option>
          <option value="STO">STO · Stock</option>
        </select>
      </label>
      <label>
        SYMBOL
        <select value={symbol} disabled={!symbols.length} onChange={e => onSymbolChange(e.target.value)}>
          <option value="">Select</option>
          {symbols.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
      </label>
      <label>
        DATE
        <select value={date} disabled={!dates.length} onChange={e => onDateChange(e.target.value)}>
          <option value="">Select</option>
          {dates.map(d => <option key={d} value={d}>{d}</option>)}
        </select>
      </label>
      <label>
        EXPIRY
        <select value={expiry} disabled={!expiries.length} onChange={e => onExpiryChange(e.target.value)}>
          <option value="">Select</option>
          {expiries.map(e => <option key={e} value={e}>{e}</option>)}
        </select>
      </label>
      <button className="oc-btn" disabled={!canLoad || loading} onClick={onLoad}>
        <i className="bi bi-table" /> LOAD
      </button>
      {summary && (
        <>
          <div className="oc-sep" />
          <div className="oc-st">
            <div className="sp"><span className="sl">SPOT</span><span className="sv sg">{fmtNum(S.spot)}</span></div>
            <div className="sp"><span className="sl">MAX PAIN</span><span className="sv">{fmtNum(S.maxPain, 0)}</span></div>
            <div className="sp"><span className="sl">PCR</span><span className="sv">{S.pcr}</span></div>
            <div className="sp"><span className="sl">CE DECAY</span><span className={`sv ${S.ceDecay >= 0 ? 'sg' : 'sr'}`}>{fmtNum(S.ceDecay)}</span></div>
            <div className="sp"><span className="sl">PE DECAY</span><span className={`sv ${S.peDecay >= 0 ? 'sr' : 'sg'}`}>{fmtNum(S.peDecay)}</span></div>
            <div className="sp"><span className="sl">SIGNAL</span><span className={`sv ${S.decaySig === 'BULLISH' ? 'sg' : 'sr'}`}>{S.decaySig}</span></div>
            <div className="oi-bx">
              <div className="oi-hd">TOTAL OI (L)</div>
              <div className="oi-row">
                <div><div className="oi-lbl">CE</div><div className={`oi-val ${ceOiClass}`}>{fmtNum((S.totCEOI || 0) / 100000, 1)}</div></div>
                <div><div className="oi-lbl">PE</div><div className={`oi-val ${peOiClass}`}>{fmtNum((S.totPEOI || 0) / 100000, 1)}</div></div>
              </div>
            </div>
            <div className="oi-bx">
              <div className="oi-hd">TOTAL COI (L)</div>
              <div className="oi-row">
                <div><div className="oi-lbl">CE</div><div className={`oi-val ${ceCoiClass}`}>{fmtNum(Math.abs(S.totCECOI || 0) / 100000, 1)}</div></div>
                <div><div className="oi-lbl">PE</div><div className={`oi-val ${peCoiClass}`}>{fmtNum(Math.abs(S.totPECOI || 0) / 100000, 1)}</div></div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}